import React,{createContext} from "react";
import { UserData } from "../models/User";
export const UserContext = createContext({
    userData:{isDealer:false,executiveManager:"",generalManager:"", accessCode:""},
    setUserData:(data:UserData) =>{}
});